import React from 'react';
import './JobList.css';

// Sample image for the left column
// import jobsBanner from 'assets/images/CareerPage/wearehiring.jpg';

const jobData = [
  {
    title: 'Data Analyst',
    description: "Are you a Data Analyst eager to apply your analytical skills and insights in a fast-paced environment? We’re seeking a results-driven professional to join our team and drive data-informed decisions as our company continues to grow and innovate.",
    link: '/career-dataanalyst'
  },
  {
    title: 'Software Developer',
    description: "Are you a Software Developer passionate about building scalable, high-performance applications? We’re looking for a creative problem-solver who excels at crafting efficient code and enjoys working on impactful projects.",
    link: '/career-softwaredeveloper'
  },
  {
    title: 'A4 Chargeman',
    description: "Are you an experienced A4 Chargeman seeking a dynamic role with plenty of room to make an impact? Join our expanding operations and help ensure the reliability and safety of our electrical systems.",
    link: '/career-chargeman'
  },
];

const JobList = () => {
  return (
    <div className="job-list-container">
      {/* <div className="job-list-image-container">
        <img
          src={jobsBanner}
          alt="Jobs Banner"
          className="job-list-image"
        />
      </div> */}

      {/* Right Column: Job Listings */}
      <div className="job-list-content">
        {/* <h3>We Are Now Hiring...</h3> */}
        {jobData.map((job, index) => (
          <div className="job-item" key={index}>
            <div className="job-header">
              <h2 className="job-title">{job.title}</h2>
              <a href={job.link} className="apply-button">
                Read More <span className="arrow-icon"></span>
              </a>
            </div>
            <p className="job-description">{job.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobList;
